import React from 'react';
import ASwitch from 'antd-mobile/lib/switch';



export default class Switch extends ASwitch {}